import { useTranslation } from 'react-i18next'

import Text from '../../Text'

import * as styles from './FileErrorTooLargeModalContent.module.css'

function FileErrorTooLargeModalContent({ files, sizeLimit }) {
  const { t } = useTranslation()

  return (
    <>
      <Text>{t('Common.FileTooLargeErrorKey')}:</Text>
      <div className={styles.TooLargeFiles}>
        {files.map((file, index) => (
          <Text key={`${file}-${index}`}>
            {file}
            {index === files.length - 1 ? '.' : ','}
          </Text>
        ))}
      </div>
      <Text>
        {t('Common.FileTooLargeErrorSizeLimitTextKey', { count: sizeLimit })}
      </Text>
    </>
  )
}

export default FileErrorTooLargeModalContent
